<template>
    <Head :title="t('perspective.pageTitle')" />
    <BaseLayout gap="none" fill-height no-top-padding content-class="items-center pt-[8vh] md:pt-[15vh]">
        <PerspectiveIntroCard
            :has-in-progress-session="props.has_in_progress_session"
            :is-starting="isStartingAssessment"
            :error-message="startAssessmentErrorMessage"
            @start="handleStartAssessment"
            @continue="handleContinueAssessment" />
        <PerspectiveDemoTools />
    </BaseLayout>
</template>

<script lang="ts">
import LeftSidebarLayout from "~vue/layouts/LeftSidebarLayout.vue";
export default { layout: LeftSidebarLayout };
</script>

<script setup lang="ts">
import { Head } from "@inertiajs/vue3";
import { type ShareBackTarget, withShareBackTarget } from "~vue/CollaborationProfile/composables/useProfileShareBack";
import BaseLayout from "~vue/components/BaseLayout.vue";
import { usePerspective } from "~vue/Perspective/composable/usePerspective";
import PerspectiveDemoTools from "~vue/Perspective/PerspectiveDemoTools.vue";
import PerspectiveIntroCard from "~vue/UserProfile/PerspectiveIntroCard.vue";
import { useI18n } from "vue-i18n";

export interface Props {
    has_in_progress_session: boolean;
    collaboration_profile_enabled: boolean;
    share_back?: boolean;
    share_back_target?: ShareBackTarget | null;
}

const props = defineProps<Props>();
const { t } = useI18n();

const { handleStartAssessment, handleContinueAssessment, isStartingAssessment, startAssessmentErrorMessage } = usePerspective({
    source: props.share_back ? "profile_share_back" : "perspective_assessment",
    questionsUrl: props.share_back ? withShareBackTarget("/perspective/questions/?source=profile_share_back", props.share_back_target?.id) : undefined,
});
</script>
